import getBikeSharingStations from './getBikeSharingStations';
import findNearest from './findNearest'

export default async function findNearestBikeSharing(start: any) {
  const stations = await getBikeSharingStations()

  return findNearest(start, stations)
}



// WEBPACK FOOTER //
// ./src/lib/findNearestBikeSharing.ts